import psyImages from "../../components/utility/psychologicalImageImports";

const gardenChoicesBg = [
  {
    label: "Дзен градина с минималистични нотки.",
    value:
      'A zen garden with minimalist gray stones and black sand.{"Gray":"3","Black":"2"}',
    imageUrl: psyImages["garden/forFormA.jpg"],
  },
  {
    label: "Жива цветна градина с рози и слънчогледи.",
    value:
      'A vibrant flower garden with red roses and yellow sunflowers.{"Red":"3","Yellow":"2"}',
    imageUrl: psyImages["garden/forFormB.jpg"],
  },
  {
    label: "Спокойна градина с вода, лалета и перуники.",
    value:
      'A peaceful garden with water, blue lilies, and purple irises.{"Blue":"3","Violet":"2"}',
    imageUrl: psyImages["garden/forFormC.jpg"],
  },
  {
    label: "Богата зеленчукова градина.",
    value:
      'A lush vegetable garden with green plants and earthy brown soil.{"Green":"3","Brown":"2"}',
    imageUrl: psyImages["garden/forFormD.jpg"],
  },
];

export default gardenChoicesBg;
